// extracted by mini-css-extract-plugin
export var centerText = "_4l-8";
export var container = "_4l-0";
export var doughnutContainer = "_4l-7";
export var legend = "_4l-a";
export var legendItemColorDisplay = "_4l-b";
export var legendItemLabel = "_4l-d";
export var legendItemValue = "_4l-c";
export var lg = "_4l-5";
export var maxWidth = "_4l-9";
export var md = "_4l-4";
export var responsive = "_4l-6";
export var sm = "_4l-3";
export var xs = "_4l-2";
export var xxs = "_4l-1";